.question {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
  text-align: center;
}

.counter {
  margin: 0;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
  font-variant-numeric: tabular-nums;
}

.roll {
  width: 100%;
  max-width: 640px;
}

.phase {
  min-height: 1.5rem;
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 700;
}
